import React from 'react';
import Svg from 'rp-react-svg-icon';
import { getSessionStatus, subscriptionTypes } from 'rp-auth';
import { trackBarrierInteraction } from 'rp-analytics';
import { TRAIT_SELECTION, TRAIT_SUBSECTION } from 'rp-analytics/lib/traits';

const subsectionTrait = { [TRAIT_SUBSECTION]: 'Horses' };
const { TIPPING } = subscriptionTypes;

const padlockIcon = (<img
    src="/svgs/padlock_unlocked.svg"
    // src="http://dev-beta.racingpost.com:8080/svgs/padlock_unlocked.svg" // for local testing
    alt="padlock_unlocked"
    className="content-barrier__body-content-icon"
/>);

const contentBarrierBodyContent = text => (
    <div className="content-barrier__body-content-text">
        {padlockIcon}
        {text}
    </div>
);

class ContentBarrier extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            session: null,
        };
    }

    async componentWillMount() {
        const { session } = await getSessionStatus();

        this.setState({ session });
    }

    handleLoginClick = () => {
        trackBarrierInteraction({
            [TRAIT_SELECTION]: 'Login',
            ...subsectionTrait,
        });
    };

    handleSubscribeOrUpgradeClick = (e) => {
        const buttonText = e.target.innerHTML.replace(/[\n\t]/g, '').trim();
        trackBarrierInteraction({
            [TRAIT_SELECTION]: buttonText,
            ...subsectionTrait,
        });
    };

    render() {
        const userRole = localStorage.getItem('userRole');
        // get the header value as it is, without checks for tab and page, since here there is no condition for showing it depending on the tab - JP-9931
        const isFreeTrial = sessionStorage.getItem('freeTrialHeader') === 'true';

        let buttonText = isFreeTrial ? 'Sign up' : 'Subscribe';
        if (userRole === TIPPING) buttonText = 'Upgrade';
        const signupLink = isFreeTrial ? `/api/auth/login/?signup=true&state=${btoa(window.location.href)}&force=true` : '/subscriptions/';

        return (
            <section className="content-barrier">
                <table className="content-barrier__blurred-row ui-table hp-formTable nonRunnerSliderSwitcher ui-table_type1">
                    <tbody className="ui-table__body">
                        <tr className="ui-table__row">
                            <td className="ui-table__cell"><div className="hp-formTable__dateWrapper">
                                <Svg
                                    iconName="videoHollow"
                                    size="Medium"
                                    className="content-barrier__blurred-row-video-icon tableShowIcon"
                                    viewBox="0 0 24 24"
                                />
                                <span
                                    className="ui-link ui-link_table js-popupLink"
                                >12Feb24
                                </span></div></td>
                            <td className="ui-table__cell">
                                <span className="blurred-row__bolded-text">Navan</span> HcH 6K
                            </td>
                            <td className="ui-table__cell">2m1f</td>
                            <td className="ui-table__cell">Gd/Y</td>
                            <td className="ui-table__cell">10-3</td>
                            <td className="ui-table__cell">F/25 <span className="content-barrier__blurred-row-bolded-text--position">Wa Wa 11-4</span></td>
                            <td className="ui-table__cell">14/1</td>
                            <td className="ui-table__cell">S W Flanagan</td>
                            <td className="ui-table__cell">94</td>
                            <td className="ui-table__cell">67</td>
                            <td className="ui-table__cell">80</td>
                        </tr>
                    </tbody>
                </table>

                <div className="content-barrier__header">
                    <div className="content-barrier__header-body">
                        <Svg
                            iconName="premium-lock"
                            className="content-barrier__padlock--lock"
                            size="Large"
                        />
                        <div className="content-barrier__header-body-text-wrapper">
                            <p className="content-barrier__header-body-text--small">
                                Full form is part of { !isFreeTrial && 'the' }
                            </p>
                            <p className="content-barrier__header-body-text--main">
                                RACING POST+
                            </p>
                        </div>
                    </div>
                </div>
                { isFreeTrial ? (
                    <div className="content-barrier__freeTrial">
                        <p className="content-barrier__subtitle">
                            Don&#39;t worry, you can still enjoy full form for free.
                        </p>
                        <p className="content-barrier__description">
                            Simply sign up for a free Racing Post account
                        </p>
                    </div>
                ) : (
                    <p className="content-barrier__description">
                        By subscribing to our <span className="content-barrier__description--bolded">Insights</span> package,
                        you&#39;ll gain access to the most detailed database in racing alongside invaluable
                        insights and statistics curated by our team of expert analysts
                    </p>
                )}
                { isFreeTrial ? (
                    <div className="content-barrier__body--freeTrial">
                        {padlockIcon}
                        <div className="content-barrier__body-content">Plus get full access to every jockey, trainer and owner profile page</div>
                    </div>
                ) :
                (<div className="content-barrier__body">
                    <div className="content-barrier__body-header">Package highlights</div>
                    <div className="content-barrier__body-content">
                        {contentBarrierBodyContent(
                            'Full access to horse, trainer, jockey and owner profile pages - including form, sales and pedigree information'
                        )}
                        {contentBarrierBodyContent(
                            'Access the Pro Card, with unrivalled race insights including runner-by-runner Spotlight assessments, ratings and statistics'
                        )}
                        {contentBarrierBodyContent('Regular email newsletters from our analysis experts')}
                    </div>
                </div>)}
                <div className="content-barrier__footer">
                    <a href={signupLink} className="content-barrier__footer-subscribe-button" onClick={this.handleSubscribeOrUpgradeClick}>
                        {buttonText}
                    </a>
                    {!this.state.session && (
                        <p className="content-barrier__footer-text">
                            { isFreeTrial ? 'Already have an account?' : 'Already a subscriber?' }
                            <a
                                href={`/api/auth/login/?state=${btoa(window.location.href)}&force=true`}
                                className="content-barrier__footer-login-link"
                                onClick={this.handleLoginClick}
                            > Log in</a>
                        </p>
                    )}
                </div>
            </section>
        );
    }
}

export default ContentBarrier;



// WEBPACK FOOTER //
// ./src/js/shared/contentBarrier/ContentBarrier.jsx